/* src/app/components/shared/autoship-edit/autoship-edit.component.scss */
#autoshipEditor .main .borderBottom {
  border-bottom: 2px solid #cfcfcf;
}
#autoshipEditor .main .borderBottom1 {
  border-bottom: 1px solid #cfcfcf;
}
#autoshipEditor .main .borderLeft {
  border-left: 2px solid #cfcfcf;
  height: auto;
}
@media only screen and (max-width: 768px) {
  #autoshipEditor .main .padding-t-20 {
    padding-top: 20px;
  }
}
#autoshipEditor .main .mx-height-30 {
  max-height: 30%;
}
#autoshipEditor .main .mx-height-10 {
  max-height: 10%;
}
#autoshipEditor .main .items {
  padding-bottom: 15px;
  margin-top: 15px !important;
}
#autoshipEditor .main .items .cart-items__images {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  overflow: hidden;
  flex: 0 0 90px;
}
#autoshipEditor .main .items .cart-items__images img {
  border-radius: 0;
  width: 100%;
  height: auto;
  margin: 0;
  flex-shrink: 0;
  max-width: 70px;
  max-height: 70px;
}
#autoshipEditor .main .items .md-avatar:first-child,
#autoshipEditor .main .items .-inner > .md-avatar:first-child {
  border-radius: 0;
  width: 90px;
  height: 90px;
}
#autoshipEditor .main .items .md-secondary-container {
  top: 87%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 10px;
}
#autoshipEditor .main .items .input-group {
  width: 88px;
  line-height: 0;
  margin-top: 10px;
}
#autoshipEditor .main .items .input-group .input-group-btn button {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 30px;
  box-shadow: none;
  cursor: pointer;
}
#autoshipEditor .main .items .input-group .input-control {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 28px;
  text-align: center;
  color: #1c7bbf;
}
#autoshipEditor .main .items .md-button.remove-items {
  position: absolute;
  top: -10px;
  right: 0;
}
#autoshipEditor .main .items mat-divider {
  left: 50px;
  bottom: -1px;
}
#autoshipEditor .main .actionButton .mat-mdc-button {
  min-width: 30px;
  padding: 0px;
}
#autoshipEditor .main .editButton {
  color: black;
  font-size: 14px;
}
#autoshipEditor .main .itemName {
  color: black;
  font-size: 15px;
  cursor: pointer;
}
#autoshipEditor .footerBottom .mat-mdc-raised-button {
  background-color: black;
  padding: 0px 6px;
  margin: 6px 0px;
  color: #ffffff;
}
#autoshipEditor .footerBottom .mat-mdc-button {
  color: black;
  font-size: 14px;
}
#autoshipEditor .color-f-s-14 {
  color: #5e5e5e;
  font-size: 14px;
}
#autoshipEditor .color-f-s-17 {
  color: #5e5e5e;
  font-size: 17px;
}
#autoshipEditor .color-f-s-12 {
  color: #212121;
  font-size: 17px;
}
#autoshipEditor .cursor-pointer {
  cursor: pointer;
}
#autoshipEditor .m-t-12 {
  margin-top: 12px;
}
/*# sourceMappingURL=autoship-edit.component.css.map */
